import { render } from "./index.vue?vue&type=template&id=1e357e94&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=1e357e94&lang=scss&scoped=true"
import "./index.vue?vue&type=style&index=1&id=1e357e94&lang=scss"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e357e94"]])

export default __exports__